module.exports = __webpack_public_path__ + "img/gongsijianjie.dab5fe36.webp";